export default __webpack_public_path__ + "static/media/apply_tech.7e73845e.webp";